
// import React from 'react'; 
// import ProtectedRoute from './ProtectedRoute';
// export const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//     return (
//         <ProtectedRoute requiredRole="admin">
//             {children}
//         </ProtectedRoute>
//     );
// };
// src/components/guards/AdminRoute.tsx

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/store/authStore';

interface AdminRouteProps {
    children: React.ReactNode;
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
    const { user, isAuthenticated } = useAuth();
    const location = useLocation();

    // Si no está autenticado, redirigir al login
    if (!isAuthenticated) {
        return (
            <Navigate
                to="/login"
                state={{ from: location }}
                replace
            />
        );
    }

    // Si no es admin, redirigir al home
    if (user?.user_type !== 'admin') {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default AdminRoute;